import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

type PropsType = {
  symbol: string;
  onClick?: () => void;
  children?: ReactNode;
  className?: string;
  isFilled?: boolean;
};

export const SymbolComponent: FC<PropsType> = ({
  symbol, onClick, children, className, isFilled
}: PropsType) => (
  <div
    onClick={onClick}
    className={classNames(
      'relative flex items-center justify-center border w-150 min-w-150 h-200 rounded overflow-hidden cursor-pointer',
      {
        'border-green-300 bg-green-50': isFilled,
        'border-gray-200': !isFilled,
      },
      className
    )}
  >
    <span
      className="absolute left-0 right-0 top-0 bottom-0 flex items-center justify-center text-133 leading-normal opacity-10 font-extralight font-arial select-none"
      style={{ top: '-10px' }}
    >
      {symbol}
    </span>
    {children}
    <div className="h-1 w-full absolute bg-primary2 opacity-60" style={{ top: '45px' }} />
    <div className="h-1 w-full absolute bg-primary2 opacity-60" style={{ top: '70px' }} />
    <div className="h-1 w-full absolute bg-primary2 opacity-60" style={{ top: '140px' }} />
  </div>
);
